import { GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasDsKeyDtSourceImplRest } from "../../data/datasources/EstadisticasDsKeyDtSourceImplRest";
import { EstadisticasDsKeyRepositoryImpl } from "../../data/repositories/EstadisticasDsKeyRepositoryImpl";
import { GetEstadisticasLlavesUseCase } from "../../bussines/useCases/GetEstadisticasLlavesUseCase";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetLlavesAnuladasMesUseCase } from "../../bussines/useCases/GetLlavesAnuladasMesUseCase";
import { GetLlavesPorExpirarUseCase } from "../../bussines/useCases/GetLlavesPorExpirarUseCase";
import { GetEstadoLlavesAnualUseCase } from "../../bussines/useCases/GetEstadoLlavesAnualUseCase";
import { GetResumenLlavesUseCase } from "../../bussines/useCases/GetResumenLlavesUseCase";

export const useEstadisticasDsKey = () => {
    const conceptosDtSourceRest = new EstadisticasDsKeyDtSourceImplRest();
    const repository = new EstadisticasDsKeyRepositoryImpl(conceptosDtSourceRest);
    const getEstadisticasLlaves = async (input: FechaParams) => {
        const useCase = new GetEstadisticasLlavesUseCase(repository);
        const result = await executeUseCase({ input, useCase });
        return result;
    };
    const getLlavesAnuladasMes = async (input: FechaParams) => {
        const useCase = new GetLlavesAnuladasMesUseCase(repository);
        const result = await executeUseCase({ input, useCase });
        return result;
    };
    const getLlavesPorExpirar = async () => {
        const useCase = new GetLlavesPorExpirarUseCase(repository);
        const result = await executeUseCase({ input: null, useCase });
        return result;
    };

    const getEstadoLlavesAnual = async (input: GetEstadoLlavesAnualParams) => {
        const useCase = new GetEstadoLlavesAnualUseCase(repository);
        const result = await executeUseCase({ input, useCase });
        return result;
    }

    const getResumenLlaves = async (input: FechaParams) => {
        const useCase = new GetResumenLlavesUseCase(repository);
        const result = await executeUseCase({ input, useCase });
        return result;
    };

    return { getEstadisticasLlaves, getLlavesAnuladasMes, getLlavesPorExpirar, getEstadoLlavesAnual, getResumenLlaves };
}